import { useEffect } from "react";

let lockCount = 0;

// The page scrolls from html, because index.css gives it overflow-x: clip, so body cannot lock it.
// The count keeps the page locked until the last of several open modals closes.
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) {
      return;
    }

    const html = document.documentElement;
    lockCount += 1;

    if (lockCount === 1) {
      // Keeps the layout from moving sideways when the scrollbar goes away
      const scrollbarWidth = window.innerWidth - html.clientWidth;
      html.style.overflow = "hidden";
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    return () => {
      lockCount -= 1;

      if (lockCount === 0) {
        html.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };
  }, [isLocked]);
};
